// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2yucQ","colMaxWidth":"Table_colMaxWidth__2eiIM"};